import { createAction, props } from '@ngrx/store';
import {
  INotificationTrigger,
  NotificationType,
} from '@boma/supplier-portal/shared/entities';

export const loadNotificationTriggers = createAction(
  '[NotificationTriggers] Load NotificationTriggers',
  props<{
    notificationTypes: NotificationType[];
    locationIds: string[];
    targetIds: string[];
  }>()
);

export const loadNotificationTriggersSuccess = createAction(
  '[NotificationTriggers] Load NotificationTriggers Success',
  props<{ notificationTriggers: INotificationTrigger[] }>()
);

export const loadNotificationTriggersFailure = createAction(
  '[NotificationTriggers] Load NotificationTriggers Failure',
  props<{ error: any }>()
);

export const updateNotificationTriggers = createAction(
  '[NotificationTriggers] Update NotificationTriggers',
  props<{ payload: UpdateNotificationTriggersProps[] }>()
);

export const updateNotificationTriggersSuccess = createAction(
  '[NotificationTriggers] Update NotificationTriggers Success'
);

export const updateNotificationTriggersFailure = createAction(
  '[NotificationTriggers] Update NotificationTriggers Failure',
  props<{ error: string }>()
);

export interface UpdateNotificationTriggersProps {
  id?: string;
  userIds: string[];
  notificationType: NotificationType;
  locationId?: string;
  targetId?: string;
}
